import slice from './llmSlice';

export const {
  llmPopulateSubjectSummary,
  llmClearSubjectSummary,
  llmSetLoading,
  llmToggleSummarySection,
  llmSetCachedRawData,
} = slice.actions;

export default slice.reducer;
